module.exports = __webpack_public_path__ + "img/flag_ger.8bd87197.jpeg";